export default function handleList (list, ofoFlowDeal, oldOfoDealId, ofoFlowWork, cbOwhData, name, params) {
  const newParams = params || {
    priceAccuracy: 2,
    quantityAccuracy: 8
  }
  const length1 = cbOwhData.length
  const arr = []
  list.forEach((item) => {
    item['baseO' + name] = item['o' + name]
    item['o' + name] = ''
    item.baseOfoWorkId = item.ofoworkId
    if (ofoFlowWork.chooseOwh === '0' && length1) {
      if (item.cbowhId) {
        const id = cbOwhData.findIndex(val => val.cbOwhId === item.cbowhId)
        if (id < 0) {
          // item.cbowhId = (ofoFlowWork.chooseOwh == '0') ? cbOwhData[0].cbOwhId : ''
          // item.cbowhName = (ofoFlowWork.chooseOwh == '0') ? cbOwhData[0].name : ''
          if (name === 'foWorkResourceId') {
            const obj = corCbowh(cbOwhData, item, 'Resource', item.cbRestypeId)
            item.cbowhId = obj.id
            item.cbowhName = obj.name
          } else {
            const obj = corCbowh(cbOwhData, item, 'Thing', item.cbRestypeId)
            item.cbowhId = obj.id
            item.cbowhName = obj.name
          }
        }
      } else {
        if (name === 'foWorkResourceId') {
          const obj = corCbowh(cbOwhData, item, 'Resource', item.cbRestypeId)
          item.cbowhId = obj.id
          item.cbowhName = obj.name
        } else {
          const obj = corCbowh(cbOwhData, item, 'Thing', item.cbRestypeId)
          item.cbowhId = obj.id
          item.cbowhName = obj.name
        }
      }
    } else {
      item.cbowhId = ''
      item.cbowhName = ''
    }
    if (ofoFlowWork.costmanagetype === '4') { // 费用模式
      item.quantity = 1
      item.total = item.total.toFixed(2)
      item.price = item.total
      item.totalVat = 0
      item.vatgroup = '0.00'
      item.cost = 0
      item.costTotal = 0
      item.costTotalVat = 0
    } else {
      if (ofoFlowDeal.ofoDealId == oldOfoDealId) { // 交易内
        item.quantity = (!ofoFlowWork.beforeworkConfig || ofoFlowWork.beforeworkConfig.indexOf('1') !== -1) ? item.openqty : 0
        // 金额
        item.total = Number(item.opentotal).toFixed(2)
      } else { // 交易外
        item.quantity = item.openqtyDeal
        // 金额
        item.total = Number(item.opentotal).toFixed(2)
      }
      if (item.quantity) {
        if (item.total) {
          // 单价
          item.price = (item.total / item.quantity).toFixed(newParams.priceAccuracy)
        } else {
          item.price = ''
        }
        if (item.costTotal) {
          // 成本单价
          item.cost = (item.costTotal / item.quantity).toFixed(newParams.priceAccuracy)
        } else {
          item.cost = ''
        }
      }
      // 税额
      item.totalVat = (item.total / (1 + Number(item.vatgroup)) * item.vatgroup).toFixed(2)
      // 成本税额
      item.costTotalVat = (item.costTotal / (1 + Number(item.vatgroup)) * item.vatgroup).toFixed(2)
    }
    if (item.quantity) {
      arr.push(item)
    }
  })
  return arr
}
function corCbowh (cbOwhData, list, type, cbRestypeId) {
  console.info('corCbowh')
  const ids = cbOwhData.map(item => item.cbOwhId)
  const k = `ofrOwh${type}List`
  const currentOwh = list[k] && list[k].length ? (list[k].find(val => val[`${type.toLowerCase()}Quantity`] > 0 && ids.includes(val.owhId)) || list[k][0]) : (cbOwhData.find(item => item.cbRestypeId === cbRestypeId) ? cbOwhData.find(item => item.cbRestypeId === cbRestypeId) : cbOwhData[0])
  if (currentOwh) {
    const index = cbOwhData.findIndex(val => val.cbOwhId === currentOwh.owhId)
    if (index >= 0) {
      return { id: currentOwh.owhId, name: currentOwh.owhName }
    }
  }
  return { id: cbOwhData[0].cbOwhId, name: cbOwhData[0].name }
}
